import { ChatLastMessageModel } from "api";
import { chatTypesEnum } from "helpers/enums";
import { OdataFilters, queryCollection } from "helpers/reqparams";
import { body, request } from "services/request";

const resource = "api/notifications";
const chatsQuery = { orderBy: ["chat/isFavorite desc", "lastMessageDate desc"] };

const setAsUnread = (chatId: number, messageId: number) =>
    request(`${resource}/setMessageAsUnread`, body({ chatId, messageId }));

// оказалось что это надо для бесконечной пагинации, пока с бка приходит ответ мы показываем на 3 страницы вперед
export const getCounts = (start: number, length: number, maxCount: number, itemsCount: number) => {
    if (itemsCount === 0 && start === 0) {
        return 0;
    }
    if (itemsCount < length) {
        maxCount = start + length;
    }
    const calculatedCount = start + length * 3;
    return {
        count: maxCount !== undefined && maxCount < calculatedCount ? maxCount : calculatedCount,
        maxCount,
        start,
    };
};

const index = (props: OdataFilters): any => {
    const { queryFilter, preparedFilter, maxCount, ...params } = props;

    const queryArr = Object.entries((queryFilter || {}) as { [x: string]: [] }).reduce(
        (acc, [key, val]) => {
            if (Array.isArray(val)) {
                return acc.concat(val.map((v) => [key, String(v)]));
            } else {
                return acc.concat([[key, String(val)]]);
            }
        },
        [] as Array<[string, string]>,
    );

    let qp = new URLSearchParams(queryArr).toString();
    let query = queryCollection(params, { filter: preparedFilter, ...chatsQuery });
    if (qp.length) {
        query = `&${query.substr(1)}`;
        qp = `?${qp}`;
    }
    const { start, length } = params as { start: number; length: number };
    return request(`${resource}/getlist${qp}${query}`, { method: "GET" }).then((res: ChatLastMessageModel[]) => {
        if (!res) {
            return res;
        }
        if (res.length > 0 || start === 0) {
            return { data: res, ...getCounts(start, length, maxCount!, res.length) };
        } else {
            return index({ ...props, start: start - length, maxCount: start });
        }
    });
};

const chatsCount = () => {
    return Promise.all([
        request(`${resource}/getChatCountWithUnreadMessages`, { method: "GET" }),
        request(`${resource}/getChatCountWithUnreadMessages?chatType=${chatTypesEnum.DriverChat}`, { method: "GET" }),
        request(`${resource}/getChatCountWithUnreadMessages?chatType=${chatTypesEnum.FixRouteBidChat}`, {
            method: "GET",
        }),
    ]).then(([notificationsCount, chatsCount, fixRouteChatsCount]) => ({
        notificationsCount,
        chatsCount,
        fixRouteChatsCount,
    }));
};

const chatMessagesCount = (chatId: number) =>
    request(`${resource}/getUnreadMessagesCount/${chatId}`, { method: "GET" });

const read = (params?: { chatId?: number; chatType: keyof typeof chatTypesEnum }) =>
    request(`${resource}/setMessagesAsRead`, body(params || {}));

export { index, read, chatsCount, chatMessagesCount, setAsUnread };
